/**
 * Created by tomers on 5/7/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var LEConfig = require("assets/config/le-env-conf");
    var template = require("user-management-templates/skills/skillEdit.tmpl");
    var Button = require("ui/button/Button");
    var InputField = require("ui/input-field/InputField");
    var Checkbox = require("ui/checkbox/Checkbox");
    var ToggleButton = require("ui/toggle-button/toggleButton");
    var Bubble = require("ui/bubble/Bubble");
    var Multiselect = require("ui/multiselect/Multiselect");
    var KpContent = require("ui.components/kpContent/kpContent");
    var SkillLoadBalanceController = require("user-management-controllers/skills/SkillLoadBalanceController");
    var SkillLoadBalanceSectionModel = require("user-management-models/SkillLoadBalanceSectionModel");
    var SkillDefaultSurveySectionView = require("user-management-views/skills/SkillDefaultSurveySectionView");
    var LoadBalanceCollection = require("user-management-collections/LoadBalanceCollection");
    var CONST = require("const");
    var RadioButtonList = require("ui/radio-button-list/RadioButtonList");
    var AccountSettingsSLAOptionView = require("user-management-views/skills/AccountSettingsSLAOptionView");
    var CustomSettingsSLAOptionView = require("user-management-views/skills/CustomSettingsSLAOptionView");
    var AccountSettingsTransferToAgentOptionView = require("user-management-views/skills/AccountSettingsTransferToAgentOptionView");
    var CustomSettingsTransferToAgentOptionView = require("user-management-views/skills/CustomSettingsTransferToAgentOptionView");
    var AccountSettingsAutoCloseOptionView = require("user-management-views/skills/AccountSettingsAutoCloseOptionView");
    var CustomSettingsAutoCloseOptionView = require("user-management-views/skills/CustomSettingsAutoCloseOptionView");
    var SchedulePicker = require("ui.components/schedule-picker/SchedulePicker");
    var SpecialOccasionPicker = require("ui.components/special-occasion-picker/SpecialOccasionPicker");

    var TOTAL_SCORE = 100;
    var FIRST_PRIORITY = 1;
    var SECOND_PRIORITY = 2;
    var SUCCESS_PERCENTAGE_CLASS = "success-percentage";

    var SkillEditView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        SkillEditView = Marionette.ItemView.extend({
            className: "skill-edit",
            template: template,
            ui:{
                skillName: ".skill-name-input",
                skillDescription: ".skill-description-input",
                skillMaxWaitTime: ".skill-max-wait-time-input",
                skillMaxWaitTimeContainer: ".skill-max-wait-time-container",
                cancelButton: ".cancel-button",
                saveButton: ".save-button",
                defaultSurvey: ".default-survey-section-wrapper",
                loadBalance: ".load-balance-section-container",
                loadBalancerKPContainer: ".load-balance-section-container .knowledge-pack-container",
                loadBalanceEnabled: ".enabled-container",
                groupsBalance: ".groups-balance-container",
                dynamicContainerP1: ".priority1 .dynamic-container",
                addAgentGroupP1: ".priority1 .add-agent-group-container",
                totalValueP1: ".priority1 .total-value",
                addSecondPriorityGroups: ".groups-balance-container .add-second-priority-groups",
                containerP2: ".priority2",
                dynamicContainerP2: ".priority2 .dynamic-container",
                addAgentGroupP2: ".priority2 .add-agent-group-container",
                deletePriorityP2: ".priority2 .delete-priority",
                totalValueP2: ".priority2 .total-value",
                wrapUpContainer: ".skill-wrap-up-time-container",
                wrapUpInputContainer: ".skill-wrap-up-input-container",
                wrapUpResetContainer: ".skill-wrap-up-reset-container",
                wrapUpIconContainer: ".skill-wrap-up-time-container .icon",
                slaConfigurationWrapper: ".sla-configuration-wrapper",
                slaConfigurationSelector: ".sla-configuration-selector",
                slaKPContainer: ".sla-configuration-wrapper .knowledge-pack-container",
                transferToAgentWrapper: ".transfer-to-agent-section-wrapper",
                transferToAgentConfigurationSelector: ".transfer-to-agent-configuration-selector",
                autoCloseWrapper: ".auto-close-section-wrapper",
                autoCloseConfigurationSelector: ".auto-close-configuration-selector",
                autoCloseKPContainer: ".auto-close-section-wrapper .knowledge-pack-container",
                lobAssignmentContainer: ".lob-assignment-section-wrapper",
                lobAssignmentMultiselectContainer: ".lob-assignment-multiselect-container",
                canTransferOption: ".can-transfer-option",
                transferSkillsMultiselectContainer: ".transfer-skills-multiselect-container",
                workingHoursReviewLimitationsKp: ".review-limitations-kp",
                workingHoursWrapper: '.skill-working-hours-section-wrapper',
                workingHoursKPContainer: ".skill-working-hours-section-wrapper .knowledge-pack-container",
                workingHoursWorkdaysRadio: ".skill-schedule-radio-list-container",
                workingHoursWorkdaysPicker: ".skill-schedule-picker-container",
                workingHoursSpecialOccasionsRadio: ".skill-special-occasion-radio-list-container",
                workingHoursSpecialOccasionsPicker: ".skill-special-occasion-picker-container",
                conversationTypeLabel: ".conversation-type-label"
            },
            uiComponents: {
                skillName: {
                    type: InputField,
                    options: {
                        el: "view.ui.skillName",
                        permutation: InputField.Permutation.B,
                        maxLength: "view.modelValidators.maxNameLength"
                    },
                    events: {
                        change: "_onNameChange"
                    }
                },
                skillDescription: {
                    type: InputField,
                    options: {
                        el: "view.ui.skillDescription",
                        permutation: InputField.Permutation.B,
                        maxLength: "view.modelValidators.maxDescriptionLength"
                    },
                    events: {
                        change: "_onDescriptionChange"
                    }
                },
                skillMaxWaitTime: {
                    type: InputField,
                    options: {
                        el: "view.ui.skillMaxWaitTime",
                        permutation: InputField.Permutation.K,
                        inputType: InputField.prototype.InputTypeEnum.WholeNumber,
                        maxLength: 4
                    },
                    events: {
                        change: "_onMaxWaitTimeChange"
                    }
                },
                canTransfer: {
                    type: Checkbox,
                    options: {
                        el: "view.ui.canTransferOption",
                        checked: "view._isTransferSkillsEnabled",
                        label: LE.translator.translate("LEUserManagement.skillEdit.transferSkill.label"),
                        permutation: Checkbox.PERMUTATION.C
                    },
                    events: {
                        "change": "_onCanTransferChecked"
                    }
                },
                transferSkills: {
                    type: Multiselect,
                    options: {
                        container: "view.ui.transferSkillsMultiselectContainer",
                        permutation: Multiselect.PERMUTATION.MEDIUM,
                        trim: true,
                        tagsContainer: {
                            inlineErrorText: LE.translator.translate("LEUIComponents.errors.tagscontainer.viewValidation.selectFromList"),
                            placeholder: LE.translator.translate("LEUserManagement.skillEdit.transferSkill.all"),
                            tagMaxWidth: "275px"
                        },
                        items: "view._getSkillsItems"
                    },
                    events: {
                        select: "_onTransferSkillsListChange",
                        unselect: "_onTransferSkillsListChange"
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_onCancel"
                    }
                },
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onSave"
                    }
                }
            },
            events: {
                "click @ui.deletePriorityP2" : "_onDeleteP2Click",
                "mouseenter @ui.wrapUpIconContainer": "_showWrapUpBubble",
                "mouseleave @ui.wrapUpIconContainer": "_closeWrapUpBubble"
            },
            modelEvents: {
                "change": "_onModelChange"
            },

            //<editor-fold desc="Marionette-Functions">
            /*-----------------------------------------------------------------------------------------------*/
            initialize: function(options) {
                this._initialize(options);
            },
            onRender: function() {
                this._onRender();
            },
            //</editor-fold>

            //<editor-fold desc="publicFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            //</editor-fold>


            //<editor-fold desc="privateFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            _initialize: function(options) {
                this.model = options.model;
                this.modelValidators = this.model.MODEL_VALIDATORS;
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.SKILL_EDIT);
                this.loadBalanceChannelP1 = LEUserManagement.media.channel(LEUserManagement.channels.SKILL_EDIT_LOAD_BALANCING_P1);
                this.loadBalanceChannelP2 = LEUserManagement.media.channel(LEUserManagement.channels.SKILL_EDIT_LOAD_BALANCING_P2);
                this.agentGroupsCollection = options.agentGroupsCollection;
                this.surveyCollection = options.surveyCollection;
                this.showCascadingLoadBalanceSection = options.showCascadingLoadBalanceSection;
                this.showLobAssignmentSection = options.showLobAssignmentSection;
                this.showScheduledWorkingHours = options.showScheduledWorkingHours;
                this.hasSLAPerSkillFeature = LE.sessionManager.hasSLAPerSkillFeature();
                this.hasMessagingTransferToAgentFeature = LE.sessionManager.hasMessagingTransferToAgentFeature();
                this.hasAutoClosePerSkillFeature = LE.sessionManager.hasAutoClosePerSkillFeature();
                this.wrapUpTimeDefaultValue = options.wrapUpTimeDefaultValue;
                this.lobsCollection = LEUserManagement.getDataManager().getLobsCollection();
                this.skillsCollection = LEUserManagement.getDataManager().getSkillsCollection();
                this.schedulesCollection = LEUserManagement.getDataManager().getSchedulesCollection();
                this.specialOccasionsCollection = LEUserManagement.getDataManager().getSpecialOccasionsCollection();
                this.siteSettingsManualShiftStatusModel = LEUserManagement.getDataManager().getSiteSettingsManualShiftStatusModel();
            },

            _onRender: function() {
                this._bindEvents();
                this._manageDefaultSurveySection();
                if (!_.isNull(this.wrapUpTimeDefaultValue)) {
                    this._renderWrapUpTime();
                    this._updateWrapUpValue();
                }
                if (this.showLobAssignmentSection) {
                    this._renderLobAssignment();
                }
                if (this.hasSLAPerSkillFeature) {
                    this._renderSLAConfiguration();
                }
                if (this.hasAutoClosePerSkillFeature) {
                    this._renderAutoClose();
                }
                if (this.showScheduledWorkingHours) {
                    this._renderScheduledWorkingHours();
                }
                if (this.hasMessagingTransferToAgentFeature) {
                    this._renderTransferToAgent();
                }
                if (LE.siteSettings.accountSettings.hideChatOptions()) {
                    this._hideChatOptions();
                }
                this._manageLoadBalanceSection();

                this._updateSkillName();
                this._updateSkillDescription();
                this._updateSkillMaxWaitTime();
                this._updateSaveButtonState();
                this._showConversationTypeLabels();
                this._showTransferSkillsMultiselect();

                this._setFocus();
            },

            _bindEvents: function() {
                this.listenTo(this.loadBalanceChannelP1, "loadBalance:model:changed", this._loadBalanceModelChanged);
                this.listenTo(this.loadBalanceChannelP1, "loadBalance:data", this._setLoadBalanceDataP1);
                this.listenTo(this.loadBalanceChannelP1, "loadBalance:change:total", this._loadBalanceTotalP1);
                this.listenTo(this.loadBalanceChannelP2, "loadBalance:model:changed", this._loadBalanceModelChanged);
                this.listenTo(this.loadBalanceChannelP2, "loadBalance:data", this._setLoadBalanceDataP2);
                this.listenTo(this.loadBalanceChannelP2, "loadBalance:change:total", this._loadBalanceTotalP2);
                this.listenTo(this.channel, "skill:change:surveyChecked", this._updateSaveButtonState);
                this.listenTo(this.channel, "skill:model:surveyChanged", this._updateSaveButtonState);
                this.listenTo(this.channel, "skill:save:error", this._onSaveError);
                this.listenTo(this.channel, "skill:change:wrapUp", this._updateWrapUpResetBtnState);
            },

            _setFocus: function() {
                var focusedComponent = (this.model.isNew()) ? this.uiComponents.skillName : this.uiComponents.skillDescription;
                focusedComponent.setFocus(true);
            },

            _showConversationTypeLabels: function() {
                // hide the labels if no messaging in the account
                var isMessagingAccount = LE.sessionManager.hasAsyncMessagingFeature();
                this.ui.conversationTypeLabel.toggleClass("hide", !isMessagingAccount);
            },

            _hideChatOptions: function () {
                this.ui.skillMaxWaitTimeContainer.addClass("hide");
                this.ui.defaultSurvey.addClass("hide");
            },

            _renderWrapUpTime: function(){
                if (!_.has(this.uiComponents, "wrapUpInput")) {
                    this.uiComponents.host$.createAndRender("wrapUpInput", {
                        type: InputField,
                        options: {
                            el: "view.ui.wrapUpInputContainer",
                            permutation: InputField.Permutation.K,
                            inputType: InputField.prototype.InputTypeEnum.numbersBetweenMinToMax,
                            range: {min:CONST.WRAP_UP_TIME.MIN_VALUE, max:CONST.WRAP_UP_TIME.MAX_VALUE},
                            errorAlign: InputField.ERROR_ALIGN.LEFT,
                            placeholder: "view.wrapUpTimeDefaultValue"
                        },
                        events: {
                            change: "_onWrapUpInputChange"
                        }
                    });
                }
                if (!_.has(this.uiComponents, "wrapUpResetBtn")) {
                    this.uiComponents.host$.createAndRender("wrapUpResetBtn", {
                        type: Button,
                        options: {
                            el: "view.ui.wrapUpResetContainer",
                            permutation: Button.PERMUTATION.BLUELINK
                        },
                        events: {
                            click: "_onWrapUpResetButtonClick"
                        }
                    });
                }
                this.ui.wrapUpContainer.removeClass("hide");
            },

            _renderScheduledWorkingHours: function() {
                this.ui.workingHoursWrapper.removeClass("hide");
                if (!_.has(this.uiComponents, "workingHoursKpLink")) {
                    this.uiComponents.host$.createAndRender("workingHoursKpLink", {
                        type: KpContent,
                        options: {
                            container: "view.ui.workingHoursKPContainer",
                            KPLink: LE.translator.translate("LEFramework.global.captions.learnMore"),
                            kpID: "shift-scheduler"
                        }
                    });
                }

                if (!_.has(this.uiComponents, "workingHoursReviewLimitationsKpLink")) {
                    this.uiComponents.host$.createAndRender("workingHoursReviewLimitationsKpLink", {
                        type: KpContent,
                        options: {
                            container: "view.ui.workingHoursReviewLimitationsKp",
                            KPLink: LE.translator.translate("LEUserManagement.skillEdit.workingHours.reviewLimitations.link"),
                            kpID: "shift-scheduler-limitations",
                            showKPIcon: false
                        }
                    });
                }

                if (!_.has(this.uiComponents, "workdaysRadioButtonList")) {
                    this.uiComponents.host$.createAndRender("workdaysRadioButtonList", {
                        type: RadioButtonList,
                        options: {
                            el: "view.ui.workingHoursWorkdaysRadio",
                            defaultSelection: "view._getSelectedWorkdaysRadioButtonOption",
                            items: "view._getWorkdaysRadioButtonItems",
                            permutation: RadioButtonList.PERMUTATION.A
                        },
                        events:{
                            change: "_onWorkdaysOptionChange"
                        }
                    });
                }

                if (!_.has(this.uiComponents, "workdaysPicker")) {
                    this.uiComponents.host$.createAndRender("workdaysPicker", {
                        type: SchedulePicker,
                        options: {
                            container: "view.ui.workingHoursWorkdaysPicker",
                            model: this.schedulesCollection.get(this.model.getWorkingHours())
                        },
                        events: {
                            "edit": "_onWorkdaysEditClick"
                        }
                    });
                }

                if (!_.has(this.uiComponents, "specialOccasionsRadioButtonList")) {
                    this.uiComponents.host$.createAndRender("specialOccasionsRadioButtonList", {
                        type: RadioButtonList,
                        options: {
                            el: "view.ui.workingHoursSpecialOccasionsRadio",
                            defaultSelection: "view._getSelectedSpecialOccasionsRadioButtonOption",
                            items: "view._getSpecialOccasionsRadioButtonItems",
                            permutation: RadioButtonList.PERMUTATION.A
                        },
                        events:{
                            change: "_onSpecialOccasionOptionChange"
                        }
                    });
                }

                if (!_.has(this.uiComponents, "specialOccasionPicker")) {
                    this.uiComponents.host$.createAndRender("specialOccasionPicker", {
                        type: SpecialOccasionPicker,
                        options: {
                            container: "view.ui.workingHoursSpecialOccasionsPicker",
                            model: this.specialOccasionsCollection.get(this.model.getSpecialOccasion())
                        },
                        events: {
                            "edit": "_onSpecialOccasionEditClick"
                        }
                    });
                }

                this._handleWorkdaysPickerVisibility();
                this._handleSpecialOccasionPickerVisibility();
            },

            _getWorkdaysRadioButtonItems: function() {
                var workdaysCustomLabel = LE.translator.translate("LEUserManagement.skillEdit.workingHours.customSettings.label");
                var workdaysAccountLabel = LE.translator.translate("LEUserManagement.skillEdit.workingHours.accountSettings.label");
                var workdaysAccountValue = "";

                if (this.siteSettingsManualShiftStatusModel.getValue() === "true") {
                    workdaysAccountValue = LE.translator.translate("LEUserManagement.skillEdit.workingHours.accountSettings.manual.label");
                }
                else {
                    var defaultItem = this.schedulesCollection.getDefaultItem();
                    if (!_.isNull(defaultItem)) {
                        workdaysAccountValue = defaultItem.getName();
                    }
                    else {
                        workdaysAccountValue = LE.translator.translate("LEUserManagement.skillEdit.workingHours.accountSettings.activeAlways.label");
                    }
                }

                workdaysAccountLabel += " (" + workdaysAccountValue + ")";

                var items = [
                    {key: this.model.WORKING_HOURS_TYPES.ACCOUNT, label: workdaysAccountLabel},
                    {key: this.model.WORKING_HOURS_TYPES.CUSTOM, label: workdaysCustomLabel},
                ];

                return items;
            },

            _getSelectedWorkdaysRadioButtonOption: function() {
                return (_.isNull(this.model.getWorkingHours())) ? this.model.WORKING_HOURS_TYPES.ACCOUNT : this.model.WORKING_HOURS_TYPES.CUSTOM;
            },

            _getSpecialOccasionsRadioButtonItems: function() {
                var specialOccasionCustomLabel = LE.translator.translate("LEUserManagement.skillEdit.workingHours.customSettings.label");
                var specialOccasionAccountLabel = LE.translator.translate("LEUserManagement.skillEdit.workingHours.accountSettings.label");
                var specialOccasionAccountValue = "";

                if (this.siteSettingsManualShiftStatusModel.getValue() === "true") {
                    specialOccasionAccountValue = LE.translator.translate("LEUserManagement.skillEdit.workingHours.accountSettings.noOccasions.label");
                }
                else {
                    var defaultItem = this.specialOccasionsCollection.getDefaultItem();
                    if (!_.isNull(defaultItem)) {
                        specialOccasionAccountValue = defaultItem.getName();
                    }
                    else {
                        specialOccasionAccountValue = LE.translator.translate("LEUserManagement.skillEdit.workingHours.accountSettings.noOccasions.label");
                    }
                }

                specialOccasionAccountLabel += " (" + specialOccasionAccountValue + ")";

                var items = [
                    {key: this.model.WORKING_HOURS_TYPES.ACCOUNT, label: specialOccasionAccountLabel},
                    {key: this.model.WORKING_HOURS_TYPES.CUSTOM, label: specialOccasionCustomLabel},
                ];

                return items;
            },

            _getSelectedSpecialOccasionsRadioButtonOption: function() {
                return (_.isNull(this.model.getSpecialOccasion())) ? this.model.WORKING_HOURS_TYPES.ACCOUNT : this.model.WORKING_HOURS_TYPES.CUSTOM;
            },

            _renderSLAConfiguration: function() {
                this.ui.slaConfigurationWrapper.removeClass("hide");
                if (!_.has(this.uiComponents, "slaKPLink")) {
                    this.uiComponents.host$.createAndRender("slaKPLink", {
                        type: KpContent,
                        options: {
                            container: "view.ui.slaKPContainer",
                            KPLink: LE.translator.translate("LEFramework.global.captions.learnMore"),
                            kpID: "configuring-response-times"
                        }
                    });
                }
                if (!_.has(this.uiComponents, "slaSelector")) {
                    this.uiComponents.host$.createAndRender("slaSelector", {
                        type:RadioButtonList,
                        options: {
                            el: "view.ui.slaConfigurationSelector",
                            defaultSelection: "view._getSelectedSLAOption",
                            items: "view._getSLARadioButtonItems",
                            permutation: RadioButtonList.PERMUTATION.A
                        },
                        events:{
                            change: "_onSLAOptionChange"
                        }
                    });
                }
            },

            _getSLARadioButtonItems: function() {
                this.accountSettingsSLAOptionView = new AccountSettingsSLAOptionView({model: this.model});
                this.customSettingsSLAOptionView = new CustomSettingsSLAOptionView({model: this.model, channel: this.channel});
                var items = [
                    {
                        key: this.model.SLA_RESPONSE_TIME_TYPES.ACCOUNT,
                        embeddedView: this.accountSettingsSLAOptionView
                    },
                    {
                        key: this.model.SLA_RESPONSE_TIME_TYPES.CUSTOM,
                        embeddedView: this.customSettingsSLAOptionView
                    }
                ];
                return items;
            },

            updateSlaTimeValues: function(slaOptions) {
                this.customSettingsSLAOptionView.updateDefaultSlaTime(slaOptions.defaultResponseTimeInSeconds);
                this.customSettingsSLAOptionView.updateUrgentSlaTime(slaOptions.urgentResponseTimeInSeconds);
                this.customSettingsSLAOptionView.updateFirstTimeSlaTime(slaOptions.firstTimeResponseTimeInSeconds);
            },

            _getSelectedSLAOption: function() {
                return this.model.getSLAResponseTimeType();
            },

            _onSLAOptionChange: function(componentId, eventName, selectedKey) {
                this.channel.trigger("skill:sla:type:change", parseInt(selectedKey, 10));
                this._updateSaveButtonState();
            },

            _renderTransferToAgent: function name(params) {
                this.ui.transferToAgentWrapper.removeClass("hide");
                if (!_.has(this.uiComponents, "transferToAgentSelector")) {
                    this.uiComponents.host$.createAndRender("transferToAgentSelector", {
                        type: RadioButtonList,
                        options: {
                            el: "view.ui.transferToAgentConfigurationSelector",
                            defaultSelection: "view._getSelectedTransferToAgentOption",
                            items: "view._getTransferToAgentRadioButtonItems",
                            permutation: RadioButtonList.PERMUTATION.A
                        },
                        events: {
                            change: "_onTransferToAgentTypeChange"
                        }
                    });
                }
            },

            _renderAutoClose: function name(params) {
                this.ui.autoCloseWrapper.removeClass("hide");
                if (!_.has(this.uiComponents, "autoCloseKPLink")) {
                    this.uiComponents.host$.createAndRender("autoCloseKPLink", {
                        type: KpContent,
                        options: {
                            container: "view.ui.autoCloseKPContainer",
                            KPLink: LE.translator.translate("LEFramework.global.captions.learnMore"),
                            kpID: "auto-close"
                        }
                    });
                }
                if (!_.has(this.uiComponents, "autoCloseSelector")) {
                    this.uiComponents.host$.createAndRender("autoCloseSelector", {
                        type: RadioButtonList,
                        options: {
                            el: "view.ui.autoCloseConfigurationSelector",
                            defaultSelection: "view._getSelectedAutoCloseOption",
                            items: "view._getAutoCloseRadioButtonItems",
                            permutation: RadioButtonList.PERMUTATION.A
                        },
                        events: {
                            change: "_onAutoCloseTypeChange"
                        }
                    });
                }
            },

            _getSelectedTransferToAgentOption: function () {
                return this.model.getTransferToAgentType();
            },

            _onTransferToAgentTypeChange: function (componentId, eventName, selectedKey) {
                this.channel.trigger("skill:transferToAgent:type:change", parseInt(selectedKey, 10));
                this._updateSaveButtonState({ valueIsChanged: true });
            },

            _getTransferToAgentRadioButtonItems: function () {
                this.accountSettingsTransferToAgentOptionView = new AccountSettingsTransferToAgentOptionView({ model: this.model });
                this.customSettingsTransferToAgentOptionView = new CustomSettingsTransferToAgentOptionView({ model: this.model, channel: this.channel });
                var items = [
                    {
                        key: this.model.TRANSFER_TO_AGENT_TYPES.ACCOUNT,
                        embeddedView: this.accountSettingsTransferToAgentOptionView
                    },
                    {
                        key: this.model.TRANSFER_TO_AGENT_TYPES.CUSTOM,
                        embeddedView: this.customSettingsTransferToAgentOptionView
                    }
                ];
                return items;
            },

            _getSelectedAutoCloseOption: function () {
                return this.model.getAutoCloseType();
            },

            _onAutoCloseTypeChange: function (componentId, eventName, selectedKey) {
                this.channel.trigger("skill:autoClose:type:change", parseInt(selectedKey, 10));
                this._updateSaveButtonState({ valueIsChanged: true });
            },

            _getAutoCloseRadioButtonItems: function () {
                this.accountSettingsAutoCloseOptionView = new AccountSettingsAutoCloseOptionView({ model: this.model });
                this.customSettingsAutoCloseOptionView = new CustomSettingsAutoCloseOptionView({ model: this.model, channel: this.channel });
                var items = [
                    {
                        key: this.model.AUTO_CLOSE_TYPES.ACCOUNT,
                        embeddedView: this.accountSettingsAutoCloseOptionView
                    },
                    {
                        key: this.model.AUTO_CLOSE_TYPES.CUSTOM,
                        embeddedView: this.customSettingsAutoCloseOptionView
                    }
                ];
                return items;
            },

            updateTransferToAgentTimeValues: function (transferToAgentInSeconds) {
                this.customSettingsTransferToAgentOptionView.updateTransferToAgentTime(transferToAgentInSeconds);
            },

            toggleCustomTransferToAgentConfigurationVisibility: function () {
                this.customSettingsTransferToAgentOptionView.toggleCustomConfigurationVisibility();
            },

            updateAutoCloseTimeValues: function (autoCloseInSeconds) {
                this.customSettingsAutoCloseOptionView.updateAutoCloseTime(autoCloseInSeconds);
            },

            toggleCustomAutoCloseConfigurationVisibility: function () {
                this.customSettingsAutoCloseOptionView.toggleCustomConfigurationVisibility();
            },

            toggleCustomConfigurationVisibility: function() {
                this.customSettingsSLAOptionView.toggleCustomConfigurationVisibility();
            },

            _renderLobAssignment: function () {
                this.ui.lobAssignmentContainer.removeClass("hide");
                if (!_.has(this.uiComponents, "lobs")) {
                    this.uiComponents.host$.createAndRender("lobs", {
                        type: Multiselect,
                        options: {
                            container: "view.ui.lobAssignmentMultiselectContainer",
                            permutation: Multiselect.PERMUTATION.MEDIUM,
                            trim: true,
                            items: "view._getLobsItems",
                            list: {
                                noItems: {
                                    visible: true,
                                    value: LE.translator.translate("LEUserManagement.skillEdit.lobAssignment.noItems.text")
                                }
                            },
                            tagsContainer: {
                                placeholder: LE.translator.translate("LEUserManagement.skillEdit.lobAssignment.placeholder"),
                                inlineErrorText: LE.translator.translate("LEUIComponents.errors.tagscontainer.viewValidation.selectFromList"),
                                tagMaxWidth: "275px"
                            }
                        },
                        events: {
                            "select": "_onLobsSelectionChanged",
                            "unselect": "_onLobsSelectionChanged"
                        }
                    });
                }
            },

            _getLobsItems: function() {
                var lobMultiSelectArr = [];
                this.lobsCollection.each(function(lobModel){
                    var isLobAllowed = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.isLobAllowedForUser, lobModel.id);
                    var isLobSelected = (_.indexOf(this.model.getLobs(), lobModel.id) > -1);
                    if (isLobAllowed || isLobSelected) {
                        lobMultiSelectArr.push({
                            id: lobModel.id,
                            value: lobModel.getName(),
                            selected: isLobSelected,
                            enabled: isLobAllowed
                        }) ;
                    }
                }, this);

                return lobMultiSelectArr;
            },

            _isTransferSkillsEnabled: function() {
                return !!this.model.getCanTransfer();
            },

            _showTransferSkillsMultiselect: function() {
                this.ui.transferSkillsMultiselectContainer.toggleClass("hide", !this._isTransferSkillsEnabled());
            },

            _onCanTransferChecked: function(event, itemView, checked) {
                this.channel.trigger("skill:change:canTransfer", checked);
                this._showTransferSkillsMultiselect();
            },

            _getSkillsItems: function() {
                var skillsArr = [];
                this.skillsCollection.each(function(skillModel){
                    if(this.model.id !== skillModel.id) {
                        var isSkillSelected = _.include(this.model.getTransferSkills(), skillModel.id);
                        skillsArr.push({
                            id: skillModel.id,
                            value: skillModel.getName(),
                            selected: isSkillSelected
                        });
                    }
                }, this);
                return skillsArr;
            },

            _onTransferSkillsListChange: function(componentId, eventName, item) {
                var skills = this.uiComponents.transferSkills.getSelectedItems();
                this.channel.trigger("skill:change:transferSkills", skills);
            },

            _manageLoadBalanceSection: function() {
                if (this._isDisplayLoadBalancingSection()) {
                    this._showKP();
                    this._renderLoadBalanceUiComponents();
                    this.isDisplayedContainerP2 = false;
                    var skillRoutingConfiguration = this.model.getSkillRoutingConfiguration();
                    this.splitSkillRoutingConfigP1 = this._splitSkillRoutingConfigByPriority(skillRoutingConfiguration, FIRST_PRIORITY);
                    this.skillLoadBalanceControllerP1 = new SkillLoadBalanceController({container: this.ui.dynamicContainerP1, loadBalanceData: this.splitSkillRoutingConfigP1, agentGroupsCollection: this.agentGroupsCollection, channel: this.loadBalanceChannelP1, priority: FIRST_PRIORITY});
                    this.skillLoadBalanceControllerP1.createLoadBalance();
                    this.ui.loadBalance.removeClass("hide");
                    if(!_.isEmpty(skillRoutingConfiguration)) {
                        this.uiComponents.loadBalanceEnabled.setChecked(true);
                        this._onLoadBalanceEnabledChange("enabled", null, true);
                        var score = this.skillLoadBalanceControllerP1.getTotalScore();
                        if(score || score === 0) {
                            this._loadBalanceTotalP1(score);
                        }
                    } else {
                        this.uiComponents.loadBalanceEnabled.setChecked(false);
                    }
                    this._manageLoadBalanceSecondPrioritySection(skillRoutingConfiguration);
                }
            },

            _onWorkdaysOptionChange: function(componentId, eventName, value) {
                var selectedItemId = (value === this.model.WORKING_HOURS_TYPES.ACCOUNT) ? null : this.uiComponents.workdaysPicker.getSelection();
                this.channel.trigger("skill:change:workingHours", {selectedItemId: selectedItemId, type:value});
                this._handleWorkdaysPickerVisibility();
            },

            _onWorkdaysEditClick: function(componentId, eventName, value) {
                this.channel.trigger("skill:open:scheduleGallery");
            },

            _onSpecialOccasionOptionChange : function(componentId, eventName, value) {
                var selectedItemId = (value === this.model.WORKING_HOURS_TYPES.ACCOUNT) ? null : this.uiComponents.specialOccasionPicker.getSelection();
                this.channel.trigger("skill:change:specialOccasion", {selectedItemId: selectedItemId, type:value});
                this._handleSpecialOccasionPickerVisibility();
            },

            _onSpecialOccasionEditClick: function(componentId, eventName, value) {
                this.channel.trigger("skill:open:specialOccasionGallery");
            },

            _handleWorkdaysPickerVisibility: function() {
                var accountSettingsSelected = this.uiComponents.workdaysRadioButtonList.getSelectedKey() === this.model.WORKING_HOURS_TYPES.ACCOUNT;
                this.ui.workingHoursWorkdaysPicker.toggleClass("hide", accountSettingsSelected);
            },

            _handleSpecialOccasionPickerVisibility: function() {
                var accountSettingsSelected = this.uiComponents.specialOccasionsRadioButtonList.getSelectedKey() === this.model.WORKING_HOURS_TYPES.ACCOUNT;
                this.ui.workingHoursSpecialOccasionsPicker.toggleClass("hide", accountSettingsSelected);
            },

            _updateWrapUpResetBtnState: function() {
                this.uiComponents.wrapUpResetBtn.setEnabled(!_.isEmpty(this.uiComponents.wrapUpInput.getValue()));
            },

            _onWrapUpResetButtonClick: function() {
                this.uiComponents.wrapUpInput.setValue("", {silent: false});
            },

            _onWrapUpInputChange: function(componentId, eventName, value) {
                this.channel.trigger("skill:change:wrapUp", value);
            },

            _updateWrapUpValue: function() {
                var wrapUpTime = _.isNull(this.model.getWrapUpTime()) ? "" : this.model.getWrapUpTime();
                this.uiComponents.wrapUpInput.setValue(wrapUpTime, {silent: false});
            },

            _showWrapUpBubble: function(event) {
                this._closeWrapUpBubble(event, true);
                this.uiComponents.host$.createAndRender("wrapUpBubble", {
                    type: Bubble,
                    options: {
                        targetControl: this.ui.wrapUpIconContainer,
                        position: Bubble.POSITION.RIGHT,
                        showCloseButton: false,
                        isDelayed: true,
                        text: LE.translator.translate({
                            key: "LEUserManagement.skillEdit.wrapUp.tooltip",
                            args: [this.wrapUpTimeDefaultValue]
                        })
                    }
                });
            },

            _closeWrapUpBubble: function(event, force) {
                if (this.uiComponents.wrapUpBubble) {
                    this.uiComponents.wrapUpBubble.close(force);
                }
            },

            _manageDefaultSurveySection: function() {
                if (this._isDisplayDefaultSurveySection()) {
                    this.skillDefaultSurveySectionView = new SkillDefaultSurveySectionView({el: this.ui.defaultSurvey, surveyCollection: this.surveyCollection, model: this.model, channel: this.channel});
                    this.ui.defaultSurvey.append(this.skillDefaultSurveySectionView.render().$el);
                }
            },

            _manageLoadBalanceSecondPrioritySection: function(skillRoutingConfiguration) {
                if (this._isDisplayLoadBalancingSection() && this.showCascadingLoadBalanceSection) {
                    this._renderLoadBalanceSecondPriorityUiComponents();
                    this.splitSkillRoutingConfigP2 = this._splitSkillRoutingConfigByPriority(skillRoutingConfiguration, SECOND_PRIORITY);
                    this.skillLoadBalanceControllerP2 = new SkillLoadBalanceController({container: this.ui.dynamicContainerP2, loadBalanceData: this.splitSkillRoutingConfigP2, agentGroupsCollection: this.agentGroupsCollection, channel: this.loadBalanceChannelP2, priority: SECOND_PRIORITY});
                    if(!_.isEmpty(this.splitSkillRoutingConfigP2)) {
                        this.skillLoadBalanceControllerP2.createLoadBalance();
                        this.ui.containerP2.removeClass("hide");
                        this.isDisplayedContainerP2 = true;
                        if(!_.isEmpty(this.splitSkillRoutingConfigP2)) {
                            var score = this.skillLoadBalanceControllerP2.getTotalScore();
                            if (score || score === 0) {
                                this._loadBalanceTotalP2(score);
                            }
                        }
                    } else {
                        this.ui.addSecondPriorityGroups.removeClass("hide");
                    }
                }
            },

            _showKP: function() {
                this.uiComponents.host$.createAndRender("loadBalancerKPLink", {
                    type: KpContent,
                    options: {
                        container: "view.ui.loadBalancerKPContainer",
                        KPLink: LE.translator.translate("LEFramework.global.captions.learnMore"),
                        kpID: "workload-allocation-between"
                    }
                });
            },

            _updateSkillName: function() {
                this.uiComponents.skillName.setValue(this.model.getName());
                if (!this.model.isNew()) {
                    this.uiComponents.skillName.setEnabled(false);
                }
            },

            _updateSkillDescription: function() {
                this.uiComponents.skillDescription.setValue(this.model.getDescription());
            },

            _updateSkillMaxWaitTime: function() {
                this.uiComponents.skillMaxWaitTime.setValue(this.model.getMaxWaitTime());
            },

            _updateSaveButtonState: function(options) {
                options = options || {};
                var isSkillModelValid = this.model.validateSaveEnabled();
                if(isSkillModelValid && this.uiComponents.loadBalanceEnabled && this.uiComponents.loadBalanceEnabled.isChecked()) {
                    isSkillModelValid = isSkillModelValid && this.skillLoadBalanceControllerP1.validateSaveEnabled();
                    if (this.showCascadingLoadBalanceSection &&  this.skillLoadBalanceControllerP2 && this.isDisplayedContainerP2) {
                        isSkillModelValid = isSkillModelValid && this.skillLoadBalanceControllerP2.validateSaveEnabled();
                    }
                }
                if(isSkillModelValid && this.skillDefaultSurveySectionView) {
                    isSkillModelValid = this.skillDefaultSurveySectionView.validateSaveEnabled();
                }

                if (!isSkillModelValid) {
                    this.uiComponents.saveButton.setEnabled(false);
                    this.uiComponents.saveButton.setTooltip(LE.translator.translate("LEUserManagement.skillEdit.saveButton.tooltip.mandatoryFields"));
                }
                else {
                    if (this.model.isValueChanged() || options.valueIsChanged) {
                        this.uiComponents.saveButton.setEnabled(true);
                        this.uiComponents.saveButton.setTooltip("");
                    }
                    else {
                        this.uiComponents.saveButton.setEnabled(false);
                        this.uiComponents.saveButton.setTooltip(LE.translator.translate("LEUserManagement.skillEdit.saveButton.tooltip.noChanges"));
                    }
                }
            },

            _onModelChange: function(options) {
                this._updateSaveButtonState(options);
            },

            _onNameChange: function(componentId, eventName, value) {
                this.channel.trigger("skill:change:name", value);
            },

            _onDescriptionChange: function(componentId, eventName, value) {
                this.channel.trigger("skill:change:description", value);
            },

            _onMaxWaitTimeChange: function(componentId, eventName, value) {
                this.channel.trigger("skill:change:maxWaitTime", value);
            },

            _onLobsSelectionChanged: function(componentId, eventName, value) {
                var lobs = this.uiComponents.lobs.getSelectedItems();
                this.channel.trigger("skill:change:lobs", lobs);
            },

            _onLoadBalanceEnabledChange: function(componentId, eventName, enabled) {
                this.ui.groupsBalance.toggleClass("hide", !enabled);
                this._updateSaveButtonState({valueIsChanged: true});
            },

            _loadBalanceTotalP1: function(score) {
                this.ui.totalValueP1.html(score + " %");
                if(score > TOTAL_SCORE) {
                    this.ui.totalValueP1.removeClass(SUCCESS_PERCENTAGE_CLASS);
                } else {
                    this.ui.totalValueP1.addClass(SUCCESS_PERCENTAGE_CLASS);
                }
            },

            _loadBalanceTotalP2: function(score) {
                this.ui.totalValueP2.html(score + " %");
                if(score > TOTAL_SCORE) {
                    this.ui.totalValueP2.removeClass(SUCCESS_PERCENTAGE_CLASS);
                } else {
                    this.ui.totalValueP2.addClass(SUCCESS_PERCENTAGE_CLASS);
                }
            },

            _setLoadBalanceData: function(data) {
                data = data || [];
                this.model.setSkillRoutingConfiguration(data);
            },

            _setLoadBalanceDataP1: function(data) {
                data = data || [];
                this.splitSkillRoutingConfigP1 = data;
            },

            _setLoadBalanceDataP2: function(data) {
                data = data || [];
                this.splitSkillRoutingConfigP2 = data;
            },

            _loadBalanceModelChanged: function(options) {
                this._onModelChange(options);
            },

            _onCancel: function() {
                this.channel.trigger("skill:cancel");
            },

            _onSave: function() {
                if(this.uiComponents.loadBalanceEnabled && this.uiComponents.loadBalanceEnabled.isChecked()) {
                    var isLoadBalanceValid = this._isLoadBalanceValid();
                    if(isLoadBalanceValid) {
                        if (this.splitSkillRoutingConfigP2) {
                            this._setLoadBalanceData(this._concatSplitLoadBalanceConfig());
                        } else {
                            this._setLoadBalanceData(this.splitSkillRoutingConfigP1);
                        }
                        this.channel.trigger("skill:save");
                    } else {
                        LEUserManagement.notifier.showError(LE.translator.translate("LEFramework.errors.generalError.on.page"));
                    }
                } else {
                    this._setLoadBalanceData();
                    this.channel.trigger("skill:save");
                }
            },

            _isLoadBalanceValid: function() {
                var isValid = true;
                var agentGroupsDuplicate = this._getAgentGroupsDuplicate();
                isValid = this._setErrorsView(this.skillLoadBalanceControllerP1, agentGroupsDuplicate) && isValid;
                if(this.isDisplayedContainerP2) {
                    isValid = this._setErrorsView(this.skillLoadBalanceControllerP2, agentGroupsDuplicate) && isValid;
                }
                return isValid;
            },

            _setErrorsView: function(controller, agentGroupsDuplicate) {
                var isValid = true;
                var score = controller.getTotalScore();
                var loadBalanceCollectionP1 = controller.getLoadBalanceCollection();
                loadBalanceCollectionP1.each(function(model) {
                    var errObj = {};
                    var itemView = controller.getViewByModel(model);
                    _.find(agentGroupsDuplicate, function(agentGroupId) {
                        if(model.getAgentGroupId().toString() === agentGroupId) {
                            errObj[SkillLoadBalanceSectionModel.KEYS.AGENT_GROUP_ID] = LE.translator.translate("LEUserManagement.skillEdit.errors.load.balancing.same.agent.group");
                            isValid = false;
                            return true;
                        }
                    }, this);
                    if(score !== TOTAL_SCORE) {
                        errObj[SkillLoadBalanceSectionModel.KEYS.SPLIT_PERCENTAGE] = LE.translator.translate("LEUserManagement.skillEdit.errors.load.balancing.percentage.100");
                        isValid = false;
                    }
                    itemView.setErrors(errObj);
                }, this);
                return isValid;
            },

            _getAgentGroupsDuplicate: function() {
                var loadBalanceCollectionMerged;
                if(!this.isDisplayedContainerP2) {
                    loadBalanceCollectionMerged = this.skillLoadBalanceControllerP1.getLoadBalanceCollection();
                } else {
                    var loadBalanceCollectionP1JSON = this.skillLoadBalanceControllerP1.getLoadBalanceCollection().toJSON();
                    var loadBalanceCollectionP2JSON = this.skillLoadBalanceControllerP2.getLoadBalanceCollection().toJSON();
                    var newCollection = loadBalanceCollectionP1JSON.concat(loadBalanceCollectionP2JSON);
                    loadBalanceCollectionMerged = new LoadBalanceCollection(newCollection);
                }
                var agentGroupsSelected = {};
                loadBalanceCollectionMerged.each(function(model) {
                    if(agentGroupsSelected[model.getAgentGroupId()] === undefined) {
                        agentGroupsSelected[model.getAgentGroupId()] = 0;
                    } else {
                        agentGroupsSelected[model.getAgentGroupId()] += 1;
                    }
                });
                var agentGroupsDuplicate = [];
                _.each(agentGroupsSelected, function(value, key) {
                    if(value > 0) {
                        agentGroupsDuplicate.push(key);
                    }
                }, this);
                return agentGroupsDuplicate;
            },

            _addAgentGroupClickP1: function() {
                this.skillLoadBalanceControllerP1.addLoadBalance();
                this._updateSaveButtonState();
            },

            _addAgentGroupClickP2: function() {
                this.skillLoadBalanceControllerP2.addLoadBalance();
                this._updateSaveButtonState();
            },

            _addSecondPriorityGroupsClick: function() {
                this.ui.addSecondPriorityGroups.addClass("hide");
                this.skillLoadBalanceControllerP2.createLoadBalance();
                this.ui.containerP2.removeClass("hide");
                this.isDisplayedContainerP2 = true;
                this._updateSaveButtonState();
                if(!_.isEmpty(this.splitSkillRoutingConfigP2)) {
                    var score = this.skillLoadBalanceControllerP2.getTotalScore();
                    if (score || score === 0) {
                        this._loadBalanceTotalP2(score);
                    }
                }
            },

            _onDeleteP2Click: function() {
                this.ui.containerP2.addClass("hide");
                this.ui.addSecondPriorityGroups.removeClass("hide");
                this.isDisplayedContainerP2 = false;
                this.skillLoadBalanceControllerP2.deleteLoadBalancePriority();
                this.splitSkillRoutingConfigP2 = [];
            },

            _splitSkillRoutingConfigByPriority: function(skillRoutingConfiguration, priority) {
                var splitSkillRoutingConfig = [];
                if(!_.isEmpty(skillRoutingConfiguration)) {
                    _.each(skillRoutingConfiguration, function(entry) {
                        if (entry.priority === priority) {
                            splitSkillRoutingConfig.push(entry);
                        }
                    }, this);
                }
                return splitSkillRoutingConfig;
            },

            _concatSplitLoadBalanceConfig: function() {
                return this.splitSkillRoutingConfigP1.concat(this.splitSkillRoutingConfigP2);
            },

            _onSaveSuccess: function() {
                this._hideErrors();
            },

            _onSaveError: function(errors) {
                this._setErrors(errors);
            },

            _setErrors: function(errors) {
                this._hideErrors();

                this.errorsOnPage = errors;

                if (_.has(errors, this.model.KEYS.NAME)) {
                    this.uiComponents.skillName.setError(true, errors[this.model.KEYS.NAME]);
                }

                if (_.has(errors, this.model.KEYS.DESCRIPTION)) {
                    this.uiComponents.skillDescription.setError(true, errors[this.model.KEYS.DESCRIPTION]);
                }

                if (_.has(errors, this.model.KEYS.MAX_WAIT_TIME)) {
                    this.uiComponents.skillMaxWaitTime.setError(true, errors[this.model.KEYS.MAX_WAIT_TIME]);
                }

                if (_.has(errors, this.model.KEYS.WORKING_HOURS) && this.uiComponents.workdaysPicker) {
                    this.uiComponents.workdaysPicker.setError(true, errors[this.model.KEYS.WORKING_HOURS]);
                }

                if (_.has(errors, this.model.KEYS.SPECIAL_OCCASION) && this.uiComponents.specialOccasionPicker) {
                    this.uiComponents.specialOccasionPicker.setError(true, errors[this.model.KEYS.SPECIAL_OCCASION]);
                }

                if (_.has(errors, this.model.KEYS.TRANSFER_TO_AGENT) && this.uiComponents.transferToAgentSelector) {
                    this.customSettingsTransferToAgentOptionView.setError(true, errors[this.model.KEYS.TRANSFER_TO_AGENT]);
                }
                
                if (_.has(errors, this.model.KEYS.AUTO_CLOSE) && this.uiComponents.autoCloseSelector) {
                    this.customSettingsAutoCloseOptionView.setError(true, errors[this.model.KEYS.AUTO_CLOSE]);
                }
            },

            _hideErrors: function () {
                this.errorsOnPage = null;
                this.uiComponents.skillName.setError(false);
                this.uiComponents.skillDescription.setError(false);
                this.uiComponents.skillMaxWaitTime.setError(false);
                if (this.uiComponents.workdaysPicker) {
                    this.uiComponents.workdaysPicker.setError(false);
                }
                if (this.uiComponents.specialOccasionPicker) {
                    this.uiComponents.specialOccasionPicker.setError(false);
                }
            },

            _isDisplayLoadBalancingSection: function () {
                return this.agentGroupsCollection && this.agentGroupsCollection.length > 2; // check if we have at least 2 more agent group except the main
            },

            _isDisplayDefaultSurveySection: function () {
                return !this.model.isNew() && this.surveyCollection && this.surveyCollection.length > 0;
            },

            _renderLoadBalanceEnabled: function() {
                this.uiComponents.host$.createAndRender("loadBalanceEnabled", {
                    type: ToggleButton,
                    options: {
                        container: "view.ui.loadBalanceEnabled",
                        checked: false,
                        transition: ToggleButton.TRANSITION.FAST
                    },
                    events: {
                        "toggleButton:change": "_onLoadBalanceEnabledChange"
                    }
                });
            },

            _renderAddAgentGroupLinkP1: function() {
                this.uiComponents.host$.createAndRender("addAgentGroupLinkP1", {
                    type: Button,
                    options: {
                        el: "view.ui.addAgentGroupP1",
                        permutation: Button.PERMUTATION.BLUELINK
                    },
                    events: {
                        "click": "_addAgentGroupClickP1"
                    }
                });
            },

            _renderAddAgentGroupLinkP2: function() {
                this.uiComponents.host$.createAndRender("addAgentGroupLinkP2", {
                    type: Button,
                    options: {
                        el: "view.ui.addAgentGroupP2",
                        permutation: Button.PERMUTATION.BLUELINK
                    },
                    events: {
                        "click": "_addAgentGroupClickP2"
                    }
                });
            },

            _renderAddSecondPriorityGroupsLink: function() {
                this.uiComponents.host$.createAndRender("addSecondPriorityGroupsLink", {
                    type: Button,
                    options: {
                        el: "view.ui.addSecondPriorityGroups",
                        permutation: Button.PERMUTATION.BLUELINK
                    },
                    events: {
                        "click": "_addSecondPriorityGroupsClick"
                    }
                });
            },

            _renderLoadBalanceUiComponents: function() {
                this._renderLoadBalanceEnabled();
                this._renderAddAgentGroupLinkP1();
            },

            _renderLoadBalanceSecondPriorityUiComponents: function() {
                this._renderAddAgentGroupLinkP2();
                this._renderAddSecondPriorityGroupsLink();
            }

            //</editor-fold>
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return SkillEditView;

});
